import React, { useState, useEffect } from "react";
import "./index.scss";
function ServiceValue({electronicContent, styleContent}) {
  const language = localStorage.getItem("i18nextLng");
  // const electronicContent = t("spaceOperations.space_part2", {
  //   returnObjects: true,
  // });
  return (
    <div className="serviceValue">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div className="serviceValue_title">{electronicContent?.title}</div>
        </div>
      </div>
      <div className="serviceValue_con" style={{ width:styleContent?.width }}>
        {electronicContent.spact_partList.map((item0, index0) => {
          return (
            <div className="serviceValue_li" key={index0}>
              <div className="serviceValue_li_img">
                <div className="serviceValue_li_icon" style={{backgroundColor:electronicContent.dotColor}}></div>
              </div>
              <div
                className="serviceValue_li_til"
                style={
                  language === "zh"
                    ? { fontSize: "26px" }
                    : { fontSize: "20px" }
                }
              >
                {item0.itemTitle}
              </div>
              <div
                className="serviceValue_li_con"
                style={
                  language === "zh"
                    ? { fontSize: "16px" }
                    : { fontSize: "14px" }
                }
              >
                {item0.itemContent}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ServiceValue;
